import Config from "@/config/Config";
export default {
  state: {
    type: "",
    currentSocialInfo: {
      userId: "",
      signinInfo: {}
    },
    kakoInfo: {
      userId: "",
      signinInfo: {}
    },
    naverInfo: {
      userId: "",
      signinInfo: {}
    },
    facebookInfo: {
      userId: "",
      signinInfo: {}
    },
    appleInfo: {
      signinInfo: {}
    },
    googleInfo: {
      userId: "",
      signinInfo: {}
    },
    isNativeCertify: false,
    branchType: undefined
  },
  mutations: {
    INIT_SOCIAL_DATA(state) {
      state.appleInfo = {};
      state.currentSocialInfo = {};
      state.facebookInfo = {};
      state.googleInfo = {};
      state.kakoInfo = {};
      state.naverInfo = {};
    },
    SETTING_FACEBOOK_DATA(state, data) {
      this.commit("INIT_SOCIAL_DATA");
      state.facebookInfo = data;
      state.currentSocialInfo = data;
      state.type = Config.SIGN_IN_ID_TYPE.FACEBOOK;
    },
    SETTING_NAVER_DATA(state, data) {
      this.commit("INIT_SOCIAL_DATA");
      state.naverInfo = data;
      state.currentSocialInfo = data;
      state.type = Config.SIGN_IN_ID_TYPE.NAVER;
    },
    SETTING_KAKAO_DATA(state, data) {
      this.commit("INIT_SOCIAL_DATA");
      state.kakoInfo = data;
      state.currentSocialInfo = data;
      state.type = Config.SIGN_IN_ID_TYPE.KAKAO;
    },
    SETTING_GOOGLE_DATA(state, data) {
      this.commit("INIT_SOCIAL_DATA");
      state.googleInfo = data;
      state.currentSocialInfo = data;
      state.type = Config.SIGN_IN_ID_TYPE.GOOGLE;
    },
    SETTING_APPLE_DATA(state, data) {
      this.commit("INIT_SOCIAL_DATA");
      state.appleInfo = data;
      state.currentSocialInfo = data;
      state.type = Config.SIGN_IN_ID_TYPE.APPLE;
    }
  }
};
